import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  createAccountCta
} = translate({
  "createAccountCta": "Cr\xE9er un compte"
});
export const loyaltyCardWelcomeOffer = translateFormatter<{
  title: RichTextFormatter;
  description: RichTextFormatter;
  amount: string;
}>("<title>{amount} cagnott\xE9s</title><description>d\xE8s le 1er achat</description>", undefined, undefined, "en");
export const loyaltyCardCashbackPercentage = translateFormatter<{
  title: RichTextFormatter;
  description: RichTextFormatter;
  percentage: string;
}>("<title>{percentage} cagnott\xE9s</title><description>sur tous vos achats</description>", undefined, undefined, "en");
export const loyaltyCardWalletAmount = translateFormatter<{
  title: RichTextFormatter;
  description: RichTextFormatter;
  amount: string;
}>("<title>{amount}</title><description>de cagnotte \xE0 d\xE9penser</description>", undefined, undefined, "en");